import React, { useEffect } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectedRingtoneDeviceSelector } from '../../store/selectors';
import { setSelectedRingtoneDevice } from '../../store/actions';
import styles from './RingtoneDeviceSelect.module.scss';

const { Option } = Select;

const RingtoneDeviceSelect = ({ devices }) => {
  const dispatch = useDispatch();

  const selectedDevice = useSelector(selectedRingtoneDeviceSelector);

  const handleChange = (_, option) => {
    dispatch(setSelectedRingtoneDevice(option.props.device));
  };

  return (
    <Select
      defaultValue="Выберите устройство"
      onChange={handleChange}
      value={selectedDevice.deviceId}
      className={styles.root}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {devices.map((device) => (
        <Option key={device.deviceId} value={device.deviceId} device={device}>
          {device.label}
        </Option>
      ))}
    </Select>
  );
};

export default RingtoneDeviceSelect;
